import { Query } from 'graphql/generated/graphqlTypes';
import { mockDoors } from 'mocks/graphqlMocks/doorFixtures';

export function mockedGetDoorsForAccessEventsFiltersData(
  getDoorsForTenant: Query['getDoorsForTenant']
): Pick<Query, 'getDoorsForTenant'> {
  return { getDoorsForTenant };
}

export const mockedGetDoorsForAccessEventsFiltersDataForQuery = mockedGetDoorsForAccessEventsFiltersData(mockDoors);
